// extracted by mini-css-extract-plugin
var _1 = "styles_box__cxcO8";
var _2 = "styles_boxHeader__tkwwo";
var _3 = "styles_boxInfo__bioaa";
var _4 = "styles_description__55nAW";
var _5 = "styles_note__UFDj1";
export { _1 as "box", _2 as "boxHeader", _3 as "boxInfo", _4 as "description", _5 as "note" }
